{
  "backButton": "Reveniți la {prevMenuButton}",
  "moreActions": "Mai multe acțiuni",
  "unavailable": "Indisponibil, extindeți pentru detalii"
}
